import React from 'react';
import { View, StyleSheet, Platform, Image, Text, TouchableOpacity } from 'react-native';
import FadeIn from 'react-native-fade-in-image';
import { MaterialIcons } from '@expo/vector-icons';
import { useEventStore } from 'src/domain/stores/useEventStore';
import Fonts from 'src/core/utils/Fonts';
import Dimens from 'src/core/utils/Dimens';
import Colors from 'src/core/utils/Colors';
import type { ApiContentBlockGallery } from 'src/core/models/api/ApiContentBlock';
import type { ApiPage } from 'src/core/models/api/ApiPage';

interface ContentBlockGalleryProps {
	data: ApiContentBlockGallery;
	onClick?: (type: string, params: { data: ApiPage }) => void;
}

function ContentBlockGallery({ data, onClick }: ContentBlockGalleryProps) {
	const eventStore = useEventStore();
	function onButtonPress() {
		const inAppLink = data.data.cb_button_app_link;

		if (!inAppLink) {
			return;
		}

		const pages = inAppLink.includes('/') ? inAppLink.split('/') : [inAppLink];
		const inAppPage = eventStore.getPageByID(pages);
		if (inAppPage) {
			onClick?.(inAppPage.type, { data: inAppPage });
		}
	}

	return (
		<TouchableOpacity onPress={() => onButtonPress()}>
			<View renderToHardwareTextureAndroid={true} style={styles.container}>
				<FadeIn>
					<Image resizeMode="cover" source={{ uri: data.data.cb_image }} style={styles.thumbnail} />
				</FadeIn>
				<Text style={styles.text}>{data.data.cb_gallery_name}</Text>
				{Platform.OS === 'ios' ? <MaterialIcons name="keyboard-arrow-right" style={styles.arrow} /> : null}
			</View>
		</TouchableOpacity>
	);
}

export default ContentBlockGallery;

const styles = StyleSheet.create({
	container: {
		flexDirection: 'row',
		alignItems: 'center',
		borderColor: Platform.OS === 'ios' ? Colors.greyBg : Colors.overlay12,
		borderBottomWidth: Platform.OS === 'ios' ? 5 : 0.3333333333333333,
		borderTopWidth: Platform.OS === 'ios' ? 5 : 0.3333333333333333,
		height: Platform.OS === 'ios' ? 80 : 56,
		marginTop: Dimens.margin10,
		marginBottom: Dimens.margin10,
	},
	thumbnail: {
		height: Platform.OS === 'ios' ? 46 : 40,
		width: Platform.OS === 'ios' ? 46 : 40,
		borderRadius: Platform.OS === 'ios' ? 3 : 50,
		marginLeft: Platform.OS === 'ios' ? Dimens.margin20 : Dimens.margin16,
	},
	text: {
		fontSize: Dimens.fontSize16,
		color: Colors.greyTextDark,
		fontFamily: Platform.OS === 'ios' ? Fonts.montserratMedium : Fonts.montserratRegular,
		marginLeft: Platform.OS === 'ios' ? 19 : Dimens.margin16,
	},
	arrow: {
		fontSize: Dimens.fontSize23,
		color: Colors.greyIcon,
		position: 'absolute',
		right: 20,
	},
});
